export const CustomerCareStyle = [
    {
        "id": "NOTE",
        "name": "Chú thích"
    },
    {
        "id": "SCHEDULE",
        "name": "Hẹn lịch"
    },
]